/** Estado de identidad y tenant activo de la sesión web (objeto + hook; el proveedor vive en AuthProvider). */
import { createContext, useContext } from 'react';
import type { UserInfo } from '@/types';

type AuthContextType = {
  user: UserInfo | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isSuperuser: boolean;
  hasPermission: (code: string) => boolean;
  setUser: (user: UserInfo | null) => void;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return ctx;
}
